import React from 'react';
import ReactDOM from 'react-dom/client';
import { Provider } from 'react-redux';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import store from './redux/setup/store';
import { Toaster } from "@/components/ui/sonner";

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <Provider store={store}>
      {/*
        Migration Lot 5bis (2026-04-30) : remplace `<ToastContainer>`
        (react-toastify) par `<Toaster>` (sonner). La durée 2000ms et
        `richColors` sont gérés dans `components/ui/sonner.tsx` —
        callsites `toast.success/error(msg)` inchangés côté API.
      */}
      <Toaster position="bottom-right" />
      <App />
    </Provider>
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
